import { useEffect, useState } from "react";

// Keep the loading spinner around for a while after loading completes so buttons feel like they're doing something

const DELAY_MS = 800;

export default function useLoadingDelay({
  disable,
  loading,
}: {
  // These can be undefined for convenience, but must be supplied:
  disable: boolean | undefined;
  loading: boolean | undefined;
}) {
  // Counts the rising edges of `loading`. The delay timer hangs off this rather than off `loading`itself, so that loading *finishing* doesn't tear the timer down — that delay is the whole point.
  const [loadStarts, setLoadStarts] = useState(0);
  useEffect(() => {
    if (loading) setLoadStarts((starts) => starts + 1);
  }, [loading]);

  // True for DELAY_MS after each time loading began.
  const [withinDelay, setWithinDelay] = useState(false);
  useEffect(() => {
    if (loadStarts === 0) return;
    setWithinDelay(true);
    const timer = setTimeout(() => setWithinDelay(false), DELAY_MS);
    return () => clearTimeout(timer);
  }, [loadStarts]);

  return !!(disable ? loading : loading || withinDelay);
}
